export default "__VITE_ASSET__d8e51e7b__"